




































































































































































import {API} from '@/services/api/api';
import {Vue, Component, Watch} from 'vue-property-decorator';
import {mapActions, mapGetters} from 'vuex';
import ShipList from '@/models/shiplist';
import Drift from 'drift-zoom';
import {getImage, Utils} from '@/utils/Utils';
import Constants from '@/utils/constants';
import {findDeckMarkerInDeckImg} from '@/utils/DeckOperations';
import Cropper from 'cropperjs';
import canvasMerge from '@/utils/CanvasMerge';
import 'cropperjs/dist/cropper.css';
import {debounce} from 'ts-debounce';
@Component({
  computed: {...mapGetters(['shipList'])},
  methods: {...mapActions(['showSuccessToast', 'showErrorToast'])},
})
export default class EditCenterPoint extends Vue {
  // form variables.
  shipList: ShipList[];
  isScreenLoading = true;
  centerFrom: number = null;
  centerUpto: number = null;
  drift = null;
  selectedShipId: number = null;
  showSuccessToast: any;
  showErrorToast: any;
  deckList = [];
  deckImageURL = '';
  createdImage = null;
  customeImageGet = false;
  btnLoader = false;
  selectedDeckId: string = null;
  // validation varibles
  shipValidationMsg = '';
  deckValidationMsg = '';
  centerFromValidationMsg = '';
  centerUptoValidationMsg = '';
  commonValidationMsg = 'This field is required';
  lengthValidationMsg = 'Can not be more than 7 digits';

  centerPointId: string = null;

  deckImage: any = null;

  //other variables
  isAutomatedEnable = true;
  cropper = null;
  scandResult: any = null;

  // initialize image cropper on image
  initCropper() {
    this.distroyCropper();
    const t = this.$refs.image as HTMLImageElement;
    const _this = this;
    let option: any;
    option = {
      crop(event) {
        const data = _this.cropper.getData(true);
        if (data) {
          _this.centerFrom = data.y;
          _this.centerUpto = data.y + data.height;
          _this.centerFromValidationMsg = '';
          _this.centerUptoValidationMsg = '';
        }
      },
      zoomable: false,
      viewMode: '2',
    };
    if (this.centerFrom !== null && this.centerUpto !== null) {
      option['data'] = {
        x: 0,
        y: this.centerFrom,
        width: t.naturalWidth,
        height: this.centerUpto - this.centerFrom,
      };
    } else {
      option['data'] = {
        x: t.naturalWidth / 3,
        y: t.naturalHeight / 3,
        width: t.naturalWidth / 3,
        height: t.naturalHeight / 3,
      };
    }
    this.cropper = new Cropper(t, option);
  }
  //re-initialized cropper on image
  distroyCropper() {
    if (this.cropper) {
      this.cropper.destroy();
      this.cropper = null;
    }
  }

  mounted() {
    this.centerPointId = this.$route.params.id as string;
    this.getCenterPointInfoById();
    document.body.addEventListener('keydown', this.keyDownEvent);
  }

  destroyed() {
    document.body.removeEventListener('keydown', this.keyDownEvent);
  }

  keyDownEvent(event) {
    let e = event || window.event;
    Utils.keyDownEvent(e, this.cropper);
  }
  // on deck load
  onDeckLoad() {
    this.initCropper();
    this.draw();
  }

  // load zoom in third image container
  onDeckLoad2() {
    this.initDriftZoom();
  }

  //get data from api
  async getCenterPointInfoById() {
    try {
      const response = await API.fetchCenterPointInfoById(this.centerPointId);
      if (response.data) {
        const data = response.data;
        this.selectedDeckId = data.deck.drawingId;
        this.selectedShipId = data.deck.ship.shipId;
        this.centerFrom = data.centerFrom;
        this.centerUpto = data.centerUpto;

        this.loadDeckListInit();
      } else {
        this.showErrorToast({msg: response.error});
      }
    } catch (error) {
      this.showErrorToast({msg: 'Network Error'});
    }
  }

  // load deck list according to ship
  async loadDeckListInit() {
    if (this.selectedShipId !== null || this.selectedShipId.toString().length > 0) {
      this.shipValidationMsg = '';
      try {
        this.isScreenLoading = true;
        const params = {
          alldecks: 1,
          withoutzones: 0,
          withoutcenter: 0,
        };
        const response = await API.fetchEmptyDecksByShipId(params, this.selectedShipId);

        if (response.data) {
          const data = response.data;
          this.deckList = data.drawings;
          this.showDeckImage();
        } else {
          this.showErrorToast({msg: response.message});
        }
      } catch (error) {
        this.showErrorToast({msg: error});
      } finally {
        // this.isScreenLoading = false;
      }
    }
  }

  //find center point and place the value in respetive field
  _findCenterPoints() {
    if (this.scandResult != null) {
      const Center = this.scandResult.Center;

      let centerFrom = Center.EndPoint.Y;
      let centerUpto = Center.StartPoint.Y;
      if (centerFrom === 0 && centerUpto === 0) {
        this.showErrorToast({msg: 'No center point found'});
        return;
      } else if (centerFrom > centerUpto) {
        let temp = centerFrom;
        centerFrom = centerUpto;
        centerUpto = temp;
      }

      this.centerFrom = parseInt(centerFrom);
      this.centerUpto = parseInt(centerUpto);
      if (this.cropper) {
        const t = this.$refs.image as HTMLImageElement;
        let data = {
          x: 0,
          y: this.centerFrom,
          width: t.naturalWidth,
          height: this.centerUpto - this.centerFrom,
        };
        this.cropper.setData(data);
      }
    } else {
      this.showErrorToast({msg: 'Center not found'});
    }
  }

  // on ship change
  onShipChange() {
    this.selectedDeckId = null;
    this.centerFrom = null;
    this.centerUpto = null;
    this.loadDeckListInit();
  }

  // change handler deck
  changeDeck() {
    this.centerFrom = null;
    this.centerUpto = null;
    this.validateShipSelect();
    this.validatedeckSelect();
    this.showDeckImage();
  }

  validateShipSelect() {
    if (this.selectedShipId === null || this.selectedShipId.toString().length < 1) {
      this.shipValidationMsg = this.commonValidationMsg;
      return false;
    } else {
      // this.deckImageURL = '';

      this.shipValidationMsg = '';
      return true;
    }
  }

  validatedeckSelect() {
    if (this.selectedDeckId === null) {
      this.deckValidationMsg = this.commonValidationMsg;
      return false;
    } else {
      this.deckValidationMsg = '';

      return true;
    }
  }

  //load image , then download image from server as blob then convert it into base64 to draw image on canvas.
  async showDeckImage() {
    const index = this.deckList.findIndex((obj: any) => obj.drawingId == this.selectedDeckId);

    if (index != -1) {
      try {
        this.deckImageURL = '';
        this.createdImage = null;
        this.isScreenLoading = true;
        this.scandResult = Utils.parseJson(this.deckList[index].scanResult);
        this.deckImageURL = await getImage(this.deckList[index].imagePath);
        this.createdImage = null;

        return true;
      } catch (error) {
        this.showErrorToast({msg: 'Network Error'});
      } finally {
        this.isScreenLoading = false;
      }
    } else {
      this.isScreenLoading = false;
    }
  }

  validatecenterFrom() {
    if (this.centerFrom === null || this.centerFrom.toString().length < 1) {
      this.centerFromValidationMsg = this.commonValidationMsg;
      return false;
    } else if (this.centerFrom.toString().length > 7) {
      this.centerFromValidationMsg = this.lengthValidationMsg;
      return false;
    } else {
      this.centerFromValidationMsg = '';
      return true;
    }
  }
  validateCenterUpto() {
    if (this.centerUpto === null || this.centerUpto.toString().length < 1) {
      this.centerUptoValidationMsg = this.commonValidationMsg;
      return false;
    } else if (this.centerUpto.toString().length > 7) {
      this.centerUptoValidationMsg = this.lengthValidationMsg;
      return false;
    } else {
      this.centerUptoValidationMsg = '';
      return true;
    }
  }

  // validate all fields
  validateAll() {
    return (
      this.validateShipSelect() && this.validatedeckSelect() && this.validatecenterFrom() && this.validateCenterUpto()
    );
  }

  //handling update form operation
  async _updateHandler() {
    if (!this.validateAll()) return;

    try {
      this.btnLoader = true;
      const formInput = {
        DeckId: this.selectedDeckId,
        CenterFrom: this.centerFrom,
        CenterUpto: this.centerUpto,
      };
      const response = await API.updateCenterPointById(this.centerPointId, formInput);
      if (response.data) {
        this.showSuccessToast({msg: response.message});
        this.goToList();
      } else {
        this.showErrorToast({msg: response.error});
      }
    } catch (error) {
      this.showErrorToast({msg: 'Network Error'});
    } finally {
      this.btnLoader = false;
    }
  }

  //navigate to list page
  goToList() {
    this.$router.go(-1);
  }

  //clear form fields
  _clearForm() {
    this.selectedShipId = null;

    this.selectedDeckId = null;
    this.centerFrom = null;
    this.centerUpto = null;
    this.shipValidationMsg = '';
    this.deckValidationMsg = '';
    this.centerFromValidationMsg = '';
    this.centerUptoValidationMsg = '';
  }
  @Watch('shipList', {immediate: true})
  loadDeckList() {}

  //initialize zoomed container on hover image
  initDriftZoom() {
    document.querySelectorAll('.drift-bounding-box').forEach((element) => {
      element.remove();
    });
    this.drift = new Drift(this.$refs.image2, {
      paneContainer: document.getElementById('ppppp'),
      // inlinePane: 900,
      inlineOffsetY: -85,
      containInline: true,
      handleTouch: false,
      inlinePane: false,
      hoverBoundingBox: true,
      zoomFactor: 5,
    });
  }

  //disbale/destroy zoom
  desableDriftZoom() {
    if (this.drift) {
      this.drift.destroy();
    }
  }
  //cropper got re-initialized
  _reseImage() {
    if (this.cropper) {
      this.cropper.reset();
    }
  }

  _getImage() {
    this.drawRect();
  }

  //draw center point on image
  drawRect() {
    if (this.cropper && this.centerFrom && this.centerUpto && this.centerFrom != 0 && this.centerUpto != 0) {
      const data = this.cropper.getData(true);
      const t = this.$refs.image as HTMLImageElement;
      this.mergeImage({
        x: 0,
        y: this.centerFrom,
        width: t.naturalWidth,
        height: this.centerUpto - this.centerFrom,
      });
    }
  }

  draw = debounce(() => this.drawRect(), 500);

  @Watch('centerFrom')
  changedCenterFrom() {
    this.draw();
  }

  @Watch('centerUpto')
  changedCenterUpto() {
    this.draw();
  }

  // draw line on center point original image
  mergeImage(path) {
    this.customeImageGet = true;
    const _this = this;
    canvasMerge(this.deckImageURL, path, {drawType: 'rect'})
      .then((b64) => {
        _this.createdImage = b64;
        _this.initDriftZoom();
        _this.customeImageGet = false;
      })
      .catch((e) => {
        _this.customeImageGet = false;
      });
  }
}
